import React from "react";

const BojIcon: React.FC = () => {
  return <img src="https://www.acmicpc.net/favicon-32x32.png" alt="BOJ icon" />;
};

export default BojIcon;
